import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import AppShell from './components/AppShell';
import HomePage from './pages/HomePage';
import NavodayaPage from './pages/NavodayaPage';
import BoardExamPage from './pages/BoardExamPage';
import TeacherPage from './pages/TeacherPage';
import ProfilePage from './pages/ProfilePage';
import NotesListPage from './pages/NotesListPage';
import BookmarksPage from './pages/BookmarksPage';
import PaymentPage from './pages/PaymentPage';
import ResourcesPage from './pages/ResourcesPage';
import QuizPage from './pages/QuizPage';
import ChatPage from './pages/ChatPage';
import LeaderboardPage from './pages/LeaderboardPage';
import CertificatePage from './pages/CertificatePage';
import NotificationsPage from './pages/NotificationsPage';
import PublishGuidePage from './pages/PublishGuidePage';
import AdminPage from './pages/AdminPage';
import ReferralPage from './pages/ReferralPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import AssetsPage from './pages/AssetsPage';
import CurriculumPage from './pages/CurriculumPage';
import LessonPlanPage from './pages/LessonPlanPage';
import SourcesPage from './pages/SourcesPage';
import AdminUploadPage from './pages/AdminUploadPage';
import NavodayaPracticePage from './pages/NavodayaPracticePage';
import BrowsePage from './pages/BrowsePage';
import ResourceViewerPage from './pages/ResourceViewerPage';
import AdminCMSPage from './pages/AdminCMSPage';
import RoleSelector from './components/RoleSelector';
import AuthCallback from './pages/AuthCallback';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from './components/ui/toaster';

function AppRouter() {
  const location = useLocation();
  // Auth callback - detect session_id from hash
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <AppShell>
      <RoleSelector />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/navodaya" element={<NavodayaPage />} />
        <Route path="/board" element={<BoardExamPage />} />
        <Route path="/teacher" element={<TeacherPage />} />
        <Route path="/notes/:category" element={<NotesListPage />} />
        <Route path="/bookmarks" element={<BookmarksPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/resources" element={<ResourcesPage />} />
        <Route path="/quiz" element={<QuizPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/leaderboard" element={<LeaderboardPage />} />
        <Route path="/certificate" element={<CertificatePage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/publish-guide" element={<PublishGuidePage />} />
        <Route path="/referral" element={<ReferralPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/assets" element={<AssetsPage />} />
        <Route path="/curriculum" element={<CurriculumPage />} />
        <Route path="/lesson-plan" element={<LessonPlanPage />} />
        <Route path="/sources" element={<SourcesPage />} />
        <Route path="/admin/upload" element={<AdminUploadPage />} />
        <Route path="/navodaya/practice" element={<NavodayaPracticePage />} />
        <Route path="/teacher/browse" element={<BrowsePage />} />
        <Route path="/teacher/browse/:classSlug" element={<BrowsePage />} />
        <Route path="/teacher/browse/:classSlug/:subjectSlug" element={<BrowsePage />} />
        <Route path="/teacher/browse/:classSlug/:subjectSlug/:topicSlug" element={<BrowsePage />} />
        <Route path="/teacher/resource/:resourceId" element={<ResourceViewerPage />} />
        <Route path="/admin/cms" element={<AdminCMSPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </AppShell>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
